import { createUseProvidedContext } from '@stenngroup/utilities';

import { ApplicationStateContext } from '@app/context/ApplicationStateContext/ApplicationStateContext';
import { IApplicationStateContext } from '../types';

export const useApplicationState = createUseProvidedContext<IApplicationStateContext>(
  ApplicationStateContext,
  'ApplicationStateContext'
);
